var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 12,
    fill: "#D0FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0355 12.8C29.0355 22.2748 19.3911 29.0896 19.3911 35.9048C19.3911 41.1374 23.709 45.3793 29.0355 45.3793C34.3614 45.3793 38.6788 41.1374 38.6788 35.9048C38.6788 29.0896 29.0355 22.2748 29.0355 12.8ZM32.9152 40.7857H25.1544V38.7193L32.9152 38.7207V40.7857ZM32.9152 33.6364L30.0878 33.635V36.416H27.9811V33.635H25.154V31.5686H27.9811V28.7905H30.0878V31.5686H32.9152V33.6364Z",
    fill: "#478F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodGreen);
export default __webpack_public_path__ + "static/media/blood_green.028022a36913c6d606346e2518ed8509.svg";
export { ForwardRef as ReactComponent };